import React from 'react';
import Header from './Header';
import Footer from './Footer';
import '../styles/ContactUs.css';
import { useState } from 'react';


import logo_futek from '../assets/FuTek_logo.svg'
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt,FaChevronRight  } from 'react-icons/fa';


const ContactUs = () => {

  const [email, setEmail] = useState('');

  const handleSubmit1 = (e) => {
    e.preventDefault();

    if (!email) {
      alert('Please enter your email address.');
      return;
    }

    const message = `Hello, I would like a quote. My email is: ${email}`;
    const encodedMessage = encodeURIComponent(message);
    const phoneNumber = '917046062908'; // Include your full international phone number (no +)

    window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');

    setEmail('');
  };

    const [formData, setFormData] = useState({
      name: '',
      email: '',
      subject: '',
      phone: '',
      message: '',
    });
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData(prev => ({ ...prev, [name]: value }));
    };
  
const handleSubmit3 = (e) => {
  e.preventDefault();

  const { name, email, subject, phone, message } = formData;
  const mailTo = 'sales@fu-tekautomation.co.in';

  const emailSubject = `🔧 New Customer Inquiry: ${subject}`;

  const emailBody = `
Dear FU-TEK Automation Team,

I hope this message finds you well. I am reaching out to inquire about your industrial automation solutions. Please find my details and message below:

━━━━━━━━━━━━━━━━━━━━━━━  
🧾 Name: ${name}  
📧 Email: ${email}  
📞 Phone: ${phone}  
📌 Subject: ${subject}  
💬 Message: ${message}  
━━━━━━━━━━━━━━━━━━━━━━━

Kindly get in touch with me at your earliest convenience.

Best regards,  
${name}
`;

  const mailtoLink = `mailto:${mailTo}?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;
  window.location.href = mailtoLink;
};

  
  return (
    <div className="ContactUs">
      <Header />

{/* Hero Banner Section */}
<section className="hero-banner3">
  <div className="hero-content">
  <h1>Contact Us</h1>
    <div className="breadcrumb">
      <span><a href="/">Home</a></span> <FaChevronRight /> <span>Contact Us</span>
    </div>
   </div>
</section>



      {/* Contact + Quote Section */}
      <div className="quote-section1">
        {/* <div className="quote-banner">
          <h2>REQUEST A QUOTE</h2>
          <p>Sign up for our newsletter and follow us on social media</p>
          <div className="quote-input">
 <form className="quote-input" onSubmit={handleSubmit1}>
      <input
        type="email"
        placeholder="Your email address"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
      <button type="submit">➤</button>
    </form>
              </div>
        </div> */}
        <div className="contact-container">
          <div className="contact-left">
            <img src={logo_futek} alt="FU-TEK Automation Logo" />
            <p>
              Over 24 years experience and knowledge international standards,
              technologically changes our industrial system, we are dedicated to
              provides the best solutions to our valued customers there are
              many variations solutions.
            </p>
            <p><strong><FaPhoneAlt /> +91 7046062908</strong><br />Mon–Fri, 9am until 6pm</p>
            <p><strong><FaEnvelope /> sales@fu-tekautomation.co.in</strong><br />We reply within 24 hours</p>
            <p><FaMapMarkerAlt /> 38, 4th Floor, Shree Siddheshwar Plaza, nr. SARDAR ESTATE,<br />New VIP Road, Vadodara, Gujarat 390019</p>
          </div>

<div className="contact-right">
      <h3>Contact Us</h3>
      <form onSubmit={handleSubmit3}>
        <div className="form-row">
          <input
            type="text"
            name="name"
            placeholder="Enter Name"
            required
            value={formData.name}
            onChange={handleChange}
          />
          <input
            type="email"
            name="email"
            placeholder="Enter Email"
            required
            value={formData.email}
            onChange={handleChange}
          />
        </div>
        <div className="form-row">
          <input
            type="text"
            name="subject"
            placeholder="Enter Subject"
            required
            value={formData.subject}
            onChange={handleChange}
          />
          <input
            type="tel"
            name="phone"
            placeholder="Enter Phone"
            required
            value={formData.phone}
            onChange={handleChange}
          />
        </div>
        <textarea
          name="message"
          placeholder="Message"
          required
          value={formData.message}
          onChange={handleChange}
        ></textarea>
        <button type="submit">Send Now</button>
      </form>
    </div>
    
    
      </div>
    </div>


 {/* Embedded Map Section */}
 <div className="map-section">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.0203520220093!2d73.22962927498442!3d22.315070042360507!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fcf82d79c3915%3A0x5f630a6c10baeb68!2sShree%20Siddheshwar%20Plaza%201%20%26%202!5e0!3m2!1sen!2sin!4v1747759898475!5m2!1sen!2sin" width="600" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        {/* <div className="map-overlay">
          <div>
            <p><strong>📞 +917046062908</strong><br />Mon–Fri, 9am until 6pm</p>
          </div>
          <div>
            <p><strong>✉️ sales@fu-tekautomation.co.in</strong><br />We reply within 24 hours</p>
          </div>
          <div>
            <p>📍 38, 4th Floor, Shree Siddheshwar Plaza, nr. SARDAR ESTATE,<br />New VIP Road, Vadodara, Gujarat 390019.</p>
          </div>
        </div> */}
      </div>



    



      <Footer />
    </div>
  );
};

export default ContactUs;